'use strict';

/**
 * This method will execute reCAPTCHA, verify the token, verify the human, and finally call the provided callback function.
 * 
 * @param {callback} callback Fn that will be executed after reCAPTCHA verifies the human
 */
export const executeCAPTCHAToken = (callback = _ => { }) => {
    if (!grecaptcha) {
        callback(null);
    }

    grecaptcha.ready(function() {
        const reCAPTCHAElement = document.querySelector("#recaptcha");

        grecaptcha.execute(reCAPTCHAElement.dataset.siteKey, { action: 'submit' })
            .then(token => callback(token));
      });
};

